import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min'

const DropDownButton = ({ title, options, image, showTitle, isActive }) => {
  const [isOpen, setIsOpen] = useState(false)

  const toggleDropdown = () => {
    setIsOpen(prevState => !prevState)
  }

  return (
    <div className={`relative mx-2 mb-1 ${isOpen ? 'pb-2' : ''}`}>
      {/* Dropdown Button */}
      <button
        onClick={toggleDropdown}
        className={`
          group w-full flex items-center px-4 py-3 rounded-xl text-gray-700 
          transition-all duration-300 ease-out hover:bg-gradient-to-r hover:from-blue-500 hover:to-blue-600 
          hover:text-white hover:shadow-lg hover:scale-[1.02] hover:-translate-y-0.5
          ${isActive ? 'bg-gradient-to-r from-blue-500 to-blue-600 text-white shadow-lg' : ''}
          ${!showTitle ? 'justify-center' : ''}
        `}
      >
        <div
          className={`
          absolute -left-2 top-0 bottom-0 w-1 rounded-r-full transition-all duration-300
          ${
            isActive
              ? 'bg-white shadow-sm'
              : 'bg-transparent group-hover:bg-white group-hover:shadow-sm'
          }
        `}
        />

        <img
          src={image}
          alt={title}
          className={`
            transition-all duration-300 relative z-10
            group-hover:scale-110 group-hover:rotate-3 group-hover:drop-shadow-sm
            ${
              isActive
                ? 'filter brightness-0 invert scale-110'
                : 'group-hover:brightness-0 group-hover:invert'
            }
            ${!showTitle ? 'mx-auto w-7 h-7' : 'mr-3 w-5 h-5'}
          `}
        />

        {showTitle && (
          <>
            <span
              className={`
              font-medium transition-all duration-300 flex-1 text-left relative z-10
              group-hover:font-semibold group-hover:tracking-wide
              ${isActive ? 'text-white' : 'group-hover:text-white'}
            `}
            >
              {title}
            </span>
            <div
              className={`
              transition-all duration-300 ml-2 relative z-10
              ${isOpen ? 'rotate-180' : ''}
            `}
            >
              {isActive ? (
                <i
                  className={`fas fa-chevron-down text-white ${
                    isOpen ? 'rotate-180' : ''
                  } transition-transform duration-300`}
                />
              ) : (
                <i
                  className={`fas fa-chevron-down text-gray-400 group-hover:text-white ${
                    isOpen ? 'rotate-180' : ''
                  } transition-all duration-300`}
                />
              )}
            </div>
          </>
        )}

        {isActive && showTitle && (
          <div className='ml-2 w-2 h-2 bg-white rounded-full animate-pulse shadow-sm' />
        )}
        <div className='absolute inset-0 rounded-xl bg-gradient-to-r from-blue-500 to-blue-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10' />
      </button>

      {/* Dropdown Menu */}
      {isOpen && showTitle && (
        <div
          className={`
          absolute top-full left-0 right-0 mt-2 bg-white rounded-xl shadow-xl border border-gray-100 
          overflow-hidden z-50 animate-in slide-in-from-top-2 duration-200
        `}
        >
          {options.map((option, index) => {
            const isOptionActive =
              window.location.pathname === (option.route || option.url || option.path)
            return (
              <NavLink
                to={{
                  pathname: option.route || option.url || option.path,
                  state: { type: option.type }
                }}
                key={option.id || index}
                className={`
                  group flex items-center px-4 py-3 text-gray-700 
                  hover:bg-gradient-to-r hover:from-blue-50 hover:to-blue-100 hover:text-blue-600
                  transition-all duration-300 ease-out border-b border-gray-50 last:border-b-0
                  hover:scale-[1.02] hover:shadow-sm
                  ${
                    isOptionActive
                      ? 'bg-gradient-to-r from-blue-50 to-blue-100 text-blue-600 border-l-4 border-blue-500 shadow-sm'
                      : ''
                  }
                `}
              >
                <img
                  src={option.image}
                  alt={option.title}
                  className='w-4 h-4 mr-3 group-hover:scale-110 group-hover:rotate-2 transition-all duration-300 filter group-hover:brightness-0 group-hover:invert'
                />
                <span className='font-medium text-sm group-hover:font-semibold transition-all duration-300'>
                  {option.title}
                </span>
                {isOptionActive && (
                  <div className='ml-auto w-2 h-2 bg-blue-500 rounded-full animate-pulse shadow-sm' />
                )}
              </NavLink>
            )
          })}
        </div>
      )}
    </div>
  )
}

DropDownButton.propTypes = {
  options: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  showTitle: PropTypes.bool.isRequired,
  isActive: PropTypes.bool
}

export default DropDownButton
